import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalConfigurationInstance extends BaseModelAPI {
	static entity = 'approvalconfigurationinstance';
	static entityName = 'approvalconfigurationinstance';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.approvalInstance = '';
			this.approvalTypeId = '';
			this.approvalType = {};
			this.description = '';
			this.appliedToId = '';
			this.appliedTo = {};
			this.approvalConfigurationInstanceDetails = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}